import { Alert, Box, Button, Grid, Paper, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';

/**
 * LeadCaptureWidget — встраиваемая форма захвата лидов.
 *
 * Props:
 * - publicKey (string) — публичный ключ организации (обязателен)
 * - apiBaseUrl (string) — базовый URL бэкенда, напр. http://localhost:5000
 * - defaultSource (string) — source по умолчанию (website)
 */
const LeadCaptureWidget = ({ publicKey, apiBaseUrl, defaultSource = 'website' }) => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    position: '',
    source: defaultSource,
    notes: ''
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: 'info', message: '' });

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message });
    setTimeout(() => setAlert({ show: false, type: 'info', message: '' }), 4000);
  };

  const onChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!publicKey) {
      showAlert('error', 'Не указан publicKey организации');
      return;
    }
    if (!form.name.trim()) {
      showAlert('error', 'Имя обязательно');
      return;
    }
    if (!form.email.trim() && !form.phone.trim()) {
      showAlert('error', 'Укажите email или телефон');
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${apiBaseUrl}/public/leads`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Org-Public-Key': publicKey
        },
        body: JSON.stringify({ ...form })
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data?.message || 'Ошибка отправки формы');
      }
      showAlert('success', 'Спасибо! Мы свяжемся с вами.');
      setForm({ name: '', email: '', phone: '', company: '', position: '', source: defaultSource, notes: '' });
    } catch (err) {
      showAlert('error', err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <form onSubmit={onSubmit}>
        <Typography variant="h6" sx={{ mb: 2 }}>Оставьте контакты</Typography>
        {alert.show && (
          <Alert severity={alert.type} sx={{ mb: 2 }}>{alert.message}</Alert>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField fullWidth label="Имя *" value={form.name} onChange={onChange('name')} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Email" type="email" value={form.email} onChange={onChange('email')} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Телефон" value={form.phone} onChange={onChange('phone')} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Компания" value={form.company} onChange={onChange('company')} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Должность" value={form.position} onChange={onChange('position')} />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Комментарий" multiline rows={3} value={form.notes} onChange={onChange('notes')} />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="submit" variant="contained" disabled={loading}>
                Отправить
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default LeadCaptureWidget;

